import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "base-form header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "График загрузки ресурсов")
], -1)
const _hoisted_2 = {
  class: "base-form",
  style: {"max-width":"unset"}
}
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = {
  class: "base-form",
  style: {"max-width":"unset"}
}
const _hoisted_5 = { style: {"float":"left"} }
const _hoisted_6 = {
  class: "base-form",
  style: {"max-width":"unset"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "base-form",
  style: {"max-width":"unset","text-align":"right"}
}, " r ", -1)
const _hoisted_8 = {
  key: 0,
  class: "base-form form",
  style: {"max-width":"unset"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_timeline_component = _resolveComponent("timeline-component")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form_item, {
                label: "Организация-исполнитель",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectedExecutiveEntity,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedExecutiveEntity) = $event)),
                    filterable: "",
                    "reserve-keyword": "",
                    placeholder: "Выберите из списка",
                    onChange: _ctx.onDatepickerChange
                  }, {
                    label: _withCtx(({ label }) => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(label), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.executiveEntities, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form_item, {
                label: "Подразделение",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectedExecutiveEntityBranch,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedExecutiveEntityBranch) = $event)),
                    filterable: "",
                    "reserve-keyword": "",
                    placeholder: "Выберите из списка",
                    disabled: !_ctx.selectedExecutiveEntity?.id,
                    onChange: _ctx.onLegalEntityBranchChange
                  }, {
                    label: _withCtx(({ label }) => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(label), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedExecutiveEntity?.branches, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "onChange"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                label: "Дата отчета",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    onChange: _ctx.onDatepickerChange,
                    modelValue: _ctx.timelineDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timelineDate) = $event)),
                    type: "date",
                    placeholder: "",
                    clearable: false
                  }, null, 8, ["onChange", "modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            (_ctx.isReadyToLoadTimelineComponent())
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_timeline_component, {
                    branch: _ctx.selectedExecutiveEntityBranch?.id,
                    visible: _ctx.isTimelineVisible,
                    schedule: _ctx.schedule,
                    scheduleDate: _ctx.timelineDate,
                    onItemClicked: _ctx.onTimleineItemClicked
                  }, null, 8, ["branch", "visible", "schedule", "scheduleDate", "onItemClicked"]),
                  (_ctx.isTimelineErrorVisible)
                    ? (_openBlock(), _createBlock(_component_el_text, {
                        key: 0,
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ошибка загрузки графика")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}